/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default { 

  resetLeave() {
    // reset store to empty
    Store.dispatch('driversLeave/setDriversLeave', {
      driversLeave: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['driversLeave/driversLeave'].length < 1) {
      try {
        const response = await Api(true).get('/drivers/leave/list_all'); ///driver_leave/list_all

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetLeave();
            return response.data.message;
          } else {
            Store.dispatch('driversLeave/setDriversLeave', {
              driversLeave: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetLeave();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('driverLeave.ts - listAll - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      }
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  search(config: {params: { startDate?: string, endDate?: string }}) {
    return Api(true).get('/drivers/leave/search', config);
  },

  create(params: {
    driverId: number,
    startDate: string,
    endDate: string,
    totalDays: number,
  }) {
    return Api(true).post('/drivers/leave/create', params);
  },

  update(params: {
    id: number,
    driverId: number,
    startDate: string,
    endDate: string,
    totalDays: number,
  }) {
    return Api(true).post('/drivers/leave/update', params);
  },

  delete(params: {
    id: number,
  }) {
    return Api(true).post('/drivers/leave/delete', params);
  },
};
